import {SessionManager} from "../../session-manager";

export function addAuthHeader(headers) {
    headers.append('Authorization', `Bearer ${SessionManager.getToken()}`)
}